import { render } from "./DentalBridgesTypes.vue?vue&type=template&id=c708d35a"
import script from "./DentalBridgesTypes.vue?vue&type=script&lang=js"
export * from "./DentalBridgesTypes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__